<template>
  <div>
    <PrepostEdit :id="id" :dialog="dialog.edit" v-on:close="close()" state="VIEW" />
    <el-table :data="tableData" stripe ref="tableStatus" size="mini" style="width: 100%">
      <el-table-column prop="tag" :label="$t('etiqueta')" center>
        <template slot-scope="scope">
          <TagLink :tag="scope.row.tag" back="PostObjectsSro" />
        </template>
      </el-table-column>
      <el-table-column prop="service" :label="$t('servico')" center></el-table-column>
      <el-table-column prop="postedAt" :label="$t('data-postagem')" width="140"></el-table-column>
      <el-table-column prop="expectedAt" :label="$t('data-prevista')" width="140"></el-table-column>
      <el-table-column label="#" width="140">
        <template slot-scope="scope">
          <el-button type="info" title="Detalhes desse objeto" icon="el-icon-more" @click=" view(scope.$index, scope.row)"
              circle></el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import TagLink from '../../../../../views/dashboard/prepost/components/TagLink';
import PrepostEdit from "@/xpost/views/services/pre.post/PrePostEdit.vue";
export default {
  name: 'PostSroMainHomeNotDeliveredStatus',
  props: ["tableData"],
  components: {
    TagLink,
    PrepostEdit,
  },
  methods: {
    close() {
      this.dialog.edit = false;
    },
    view(index, row) {
      const vm = this;
      console.log('row', row);
      vm.id = row.tag;
      vm.dialog.edit = true;
    },
  },
  data() {
    return {
      id: "",
      dialog: {
        edit: false,
      }
    }
  }
}
</script>
